import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakePronouns, fakeProviderType } from "@/__mocks__/mockBaseTypes";
import { AvatarUserTypeValues } from "@/ui/core/Avatar";
import type { AvatarCardProps } from "@/ui/core/AvatarCard";
import AvatarCard from "@/ui/core/AvatarCard";

const StoryMeta: Meta<AvatarCardProps> = {
  title: "Core/Avatar Card",
  component: AvatarCard,
  argTypes: {
    overflowBehavior: { control: "select", options: ["ellipsize", "wrap"] },
    pronouns: { control: "object" },
    shouldShowSubtitle: { control: "boolean" },
    subtitle: { control: "text" },
    userId: { control: "text" },
    userName: { control: "text" },
    userType: {
      control: "select",
      options: Object.values(AvatarUserTypeValues),
    },
  },
  args: {
    shouldShowSubtitle: true,
    userId: "ux-123",
    userName: "Olive Lee",
    userType: AvatarUserTypeValues.provider,
  },
};

type Story = StoryObj<AvatarCardProps>;

const Primary: Story = {};
const WithPronouns: Story = {
  args: {
    pronouns: ["she/her"],
  },
};
const WithSubtitle: Story = {
  args: {
    subtitle: "Father",
    userType: "support",
  },
};
const WithoutSubtitle: Story = {
  args: {
    shouldShowSubtitle: false,
  },
};
const WithHorizontal: Story = {
  args: {
    isHorizontal: true,
  },
};
const WithOverflowingLines: Story = {
  args: {
    overflowBehavior: "ellipsize",
    pronouns: fakePronouns({ max: 200, min: 100 }),
    subtitle: faker.helpers
      .multiple(() => fakeProviderType(), {
        count: faker.number.int({ max: 200, min: 100 }),
      })
      .join(", "),
    userName: faker.helpers
      .multiple(() => faker.person.fullName(), {
        count: faker.number.int({ max: 200, min: 100 }),
      })
      .join(", "),
  },
};

export {
  Primary,
  WithHorizontal,
  WithoutSubtitle,
  WithOverflowingLines,
  WithPronouns,
  WithSubtitle,
};
export default StoryMeta;
